import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { MasterPage } from './features/master/MasterPage';
import { MemoryPage } from './features/memory/MemoryPage';
import { OrdersPage } from './features/orders/OrdersPage';
import { OrderDetailPage } from './features/orders/OrderDetailPage';
import { HistoryPage } from './features/history/HistoryPage';
import { SearchPage } from './features/search/SearchPage';
import { UploadPage } from './features/upload/UploadPage';
import { OcrPage } from './features/ocr/OcrPage';
import { UsersPage } from './features/users/UsersPage';
import { RegisterPage } from './features/users/RegisterPage';
import { USER_AUTH_ENABLED } from './features/users/roles';

const DEV = import.meta.env.DEV;
// マスタ管理/ユーザー管理ルート: 認証有効時(本番) or dev のみ存在。MVP(認証無効・本番ビルド)では無し
const adminRoutesEnabled = USER_AUTH_ENABLED || DEV;

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <UploadPage /> },
      { path: 'ocr', element: <OcrPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/:orderId', element: <OrderDetailPage /> },
      ...(adminRoutesEnabled ? [{ path: 'master', element: <MasterPage /> }] : []),
      // 開発者専用ツール（localhost のみ）
      ...(DEV ? [{ path: 'history', element: <HistoryPage /> }] : []),
      ...(DEV ? [{ path: 'memory', element: <MemoryPage /> }] : []),
      ...(DEV ? [{ path: 'search', element: <SearchPage /> }] : []),
      ...(adminRoutesEnabled ? [{ path: 'users', element: <UsersPage /> }] : []),
      // 初回登録/承認待ちの受け皿（認証有効時のみ）
      ...(USER_AUTH_ENABLED ? [{ path: 'register', element: <RegisterPage /> }] : []),
    ],
  },
]);
